import type { UnitDefinition } from "@src/types/units";

/**
 * Ids stored in widgets are unit ids (`unit_id`, e.g. "Dg=="); the catalog
 * may key entries differently, so lookup resolves by unit_id across values.
 */
export const getUnitById = (
  units: Record<string, UnitDefinition>,
  id: string | null | undefined,
): UnitDefinition | null => {
  if (!id) return null;
  return Object.values(units).find((u) => u.unit_id === id) ?? null;
};
